import React from 'react'
import { SocialLinks } from '../SocialLinks'
import { Apps } from '../Apps'
import config from 'SRC/config/config.yaml'

let itemCounter = 1
export const columns = config.footer.menu.map((column, index) => ({
  id: index + 1,
  isCategories: Boolean(column.categories),
  apps: Boolean(column.apps),
  title: column.title,
  className: column.className,
  items: Array.isArray(column.items) ? column.items.map((item) => ({
    id: itemCounter++,
    link: item.link,
    title: item.title,
    targetBlank: item.targetBlank
  })) : [],
  child: column.child === 'social' ? <SocialLinks key='social-links' /> : null
}))
